export const ImgButton = ({handleClick, asset, alt})=>{
    return (
        <img onClick={handleClick} style={{'cursor':'pointer'}} src={process.env.PUBLIC_URL + '/assets/'+asset} alt={alt}/>
    )
}